import React, { Fragment } from 'react';
import './Header.css';

export const Header = () => (
  <Fragment>
    <div className='header'>
      <div className='wrapper'>
        <div className='logo'>
          <img src='http://wpm.ccmp.eu/wpm/409/Images_2019_neu/01_Logo.png' alt='' />
        </div>
        <div className='s-h50'></div>
      </div>
    </div>
  </Fragment>
);
